import { Button } from '@neo/index'
import { formatCurrency } from 'v2/shared/utils'

interface RechargeAmountTileProps {
  title: string
  selectedAmount: number
  onSelect: (amount: number) => void
  rechargeChoicesData: {
    choicesList: number[]
    currency: string
  }
  disabled?: boolean
  maxSelectable?: number
}

export const RechargeAmountTile = ({
  title,
  selectedAmount,
  onSelect,
  rechargeChoicesData,
  disabled = false,
  maxSelectable,
}: RechargeAmountTileProps) => {
  const sortedRechargeChoices = rechargeChoicesData.choicesList
    ? [...rechargeChoicesData.choicesList].sort((a, b) => a - b)
    : []
  const hasLimit = maxSelectable !== undefined && Number.isFinite(maxSelectable)
  return (
    <div>
      <h4 className="mb-2 text-p-600">{title}</h4>
      <div className="gap-2 w-full flex flex-wrap">
        {sortedRechargeChoices?.map((amount) => {
          const overLimit = hasLimit && amount > (maxSelectable as number)
          const isDisabled = disabled || overLimit
          return (
            <Button
              key={amount}
              type="button"
              variant={selectedAmount === amount ? 'default' : 'outline'}
              onClick={() => onSelect(amount)}
              className="px-3 py-2 w-fit"
              data-testid={`button-amount-${amount}`}
              disabled={isDisabled}
            >
              {formatCurrency(amount, rechargeChoicesData.currency, false)}
            </Button>
          )
        })}
      </div>
    </div>
  )
}
